import React, { useEffect, useState } from 'react';

import { FaCartPlus, FaHeart, FaShare } from 'react-icons/fa';
import { BsFillLightningChargeFill } from 'react-icons/bs';
import {
  AiOutlineCalendar,
  AiOutlineClose,
  AiOutlineCoffee,
} from 'react-icons/ai';
import FlightsClock from '../../../shared/components/FlightsClock';
import { IoBedOutline } from 'react-icons/io5';

import formatNumber from '../utils/formatNumber';
import moment from 'moment';
import { getTourDataForCurrentTour } from '../utils/getTourDataForCurrentTour';
import checkLikedOrAddedToCardTour from '../../../shared/lib/checkLikedOrAddedToCardTour';
import { CURRENCY_MAP_ICON } from '../constants/CurrencyClasses';
import { getRowValid } from '../utils/getRowValid';
import { Link } from 'react-router-dom';

const OneTouristTour = ({
  departure,
  request_model,
  row,
  likes,
  carts,
  isAuth,
  onCartUpdate,
  tour,
  hideoperator = false,
  row_fix,
  setTourToShare,
  setOpenModal,
  setTourLike,
  setTourToCart,
  handleOfficeSave,
  ...rest
}) => {
  const [geoKeyLikedTour, setGeoKeyLikedTour] = useState(null);
  const [geoKeyAddedToCartTour, setGeoKeyAddedToCartTour] = useState(null);
  const [isTourCardHidden, setTourCardHidden] = useState(false);

  const row_valid = getRowValid(row_fix, tour);

  let currentTourData = getTourDataForCurrentTour(
    row,
    tour,
    departure,
    request_model
  );

  function hideTourCard() {
    setTourCardHidden(!isTourCardHidden);
  }

  useEffect(() => {
    const tourId = tour.tourid;
    const LikedTour = checkLikedOrAddedToCardTour(tourId, likes);
    if (LikedTour) {
      setGeoKeyLikedTour(LikedTour);
    }
  }, [likes]);

  useEffect(() => {
    const tourId = tour.tourid;
    const AddedToCartTour = checkLikedOrAddedToCardTour(tourId, carts);

    if (AddedToCartTour) {
      setGeoKeyAddedToCartTour(AddedToCartTour);
    }
  }, [carts]);

  return (
    <article
      className={`tourist-mini-tour${
        isTourCardHidden ? ' tourist-mini-tour_hidden' : ''
      }`}
    >
      <div className={`tourist--mini-tour`}>
        <AiOutlineClose
          title="Скрыть данный отель"
          className="tourist-mini-tour__close-btn"
          onClick={hideTourCard}
        />
        <div className="tour__flight">
          <div className="tour__info-block tour__dates-info">
            <div className="tour__info tour__info-dates">
              <AiOutlineCalendar className="tour__icon" />
              <span className="tour__info-dates-period">
                {moment(tour.flydate, 'DD.MM.YYYY').format('DD MMM')}
                {' — '}
                {moment(tour.flydate, 'DD.MM.YYYY')
                  .add('day', +tour.nights)
                  .format('DD MMM')}
              </span>
              <span className="tour__info-dates-nights">
                {` (${tour.nights} ночей)`}
              </span>
            </div>
            <FlightsClock tour_id={tour.tourid} />
          </div>
          <div className="tour__info-block tour__info-hotel">
            <div className="tour__info tour__meal-info">
              <AiOutlineCoffee className="tour__icon" />
              {`${tour.meal} - ${tour.mealrussian}`}
            </div>
            <div className="tour__info tour__room-info">
              <IoBedOutline className="tour__icon" />
              {`${tour.placement} | ${tour.room}`}
            </div>
          </div>
        </div>
        <div className="tour__hotel">
          <div className="tour__info-block">{tour.tourname}</div>
        </div>
        <div className="tour__actions">
          {!hideoperator ? (
            <img
              src={`https://geograftour.com/static/index/img/touroperator/tourvisor/${tour.operatorcode}.png`}
              alt={row.tours.tour[0].operatorname}
              className="tour__operator-logo"
              loading="lazy"
            />
          ) : null}
          <div className="tour__cabinet-btns">
            <FaShare
              title="Поделиться туром"
              className="tour__cabinet-button"
              onClick={(e) => {
                e.preventDefault();
                setOpenModal(true);
                setTourToShare(row_valid);
              }}
            />
            <FaHeart
              title="Добавить тур в избранное"
              className={`like like-${
                row.tours.tour[0].tourid === tour.tourid
                  ? !!rest.geoKeyLikedTour
                  : !!geoKeyLikedTour
              } tour__cabinet-button`}
              onClick={() => {
                setTourLike(currentTourData);
              }}
            />
            <FaCartPlus
              title="Добавить тур в корзину"
              className={`cart cart-${
                row.tours.tour[0].tourid === tour.tourid
                  ? !!rest.geoKeyAddedToCartTour
                  : !!geoKeyAddedToCartTour
              } tour__cabinet-button`}
              onClick={() => {
                setTourToCart(currentTourData);
              }}
            />
          </div>
          <Link
            to={`https://www.geograftour.com/tours/tour-info/${row_valid.offer_id}/`}
            className="tour__link"
            onClick={handleOfficeSave}
            target="_blank"
          >
            {tour.hotelstatus === 2 && (
              <span className="permanent-booking-container">
                <BsFillLightningChargeFill
                  className="permanent-booking-icon"
                  title="Мгновенное бронирование"
                />
              </span>
            )}
            <span className="tour__link-price">
              {formatNumber(tour.price)}{' '}
              <small>{CURRENCY_MAP_ICON[tour.currency]}</small>
            </span>
          </Link>
        </div>
      </div>
    </article>
  );
};

export default OneTouristTour;
